var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack544({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.4,9.69l-.59-.46a8.35,8.35,0,0,1,.59-.6l.15-.15L7,8.35l-.44-.12.23-.69A6.07,6.07,0,0,1,7.7,8a6.61,6.61,0,0,1-.1-1h.7a9.7,9.7,0,0,1-.11,1l.34-.16.65-.27.2.71c-.28.06-.62.13-1,.19L8.85,9c.09.1.17.19.22.26l-.6.39L8,8.79C7.79,9.07,7.61,9.37,7.4,9.69Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack544);
export default __webpack_public_path__ + "static/media/Symbolpack_5_44.8675cd2c754096e55824a3453796803c.svg";
export { ForwardRef as ReactComponent };